import { Button, Typography } from "@mui/material";
import { Box, styled } from "@mui/system";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { downloadProject, fetchProjectPdf } from "../../../../api/handleProjects";
import FinalDocumentsPreview from "../../../FinalDocuments/FinalDocumentsPreview";

const DownloadButton = styled(Button)(({ theme }) => ({
  width: "100%", // Hacer que el botón sea igual de largo
  marginTop: theme.spacing(2), // Espaciado superior
  backgroundColor: "#0072C6",
  color: "#ffffff",
  "&:hover": {
    backgroundColor: "#005B9A",
  },
  borderRadius: "4px",
}));

const PdfPreviewBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "500px", // Mantén altura fija
  border: "1px solid #ccc",
  borderRadius: "4px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#f9f9f9",
  marginTop: theme.spacing(2),
}));

const ProjectPdfComponent = ({ groupId, groupNumber, projectType }) => {
  const period = useSelector((state) => state.period);
  const user = useSelector((state) => state.user);
  const [pdfUrl, setPdfUrl] = useState(null);

  const downloadFile = async () => {
    try {
      // Llama a la función genérica para descargar el proyecto (inicial o final)
      const projectKey = projectType === "Anteproyecto" ? 'initial-project' : 'final-project';
      await downloadProject(groupId, user, period.id, projectKey, groupNumber);
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
    }
  };

  // Función para cargar el PDF en la previsualización
  const loadPdfPreview = async () => {
    try {
      const projectKey = projectType === "Anteproyecto" ? 'initial' : 'final';
      const url = await fetchProjectPdf(groupId, user, period.id, projectKey);
      setPdfUrl(url); // Guarda la URL en el estado
    } catch (error) {
      console.error("Error al cargar la previsualización del PDF:", error);
    }
  };

  const isFinal = projectType !== "Anteproyecto";

  useEffect(() => {
    // La entrega final tiene su propio visor, con un PDF por documento.
    if (!isFinal) loadPdfPreview();
  }, [groupId, user, period]);

  if (isFinal) {
    return (
      <>
        <Typography variant="h4" align="center" gutterBottom marginTop={1}>
          {projectType}
        </Typography>
        <FinalDocumentsPreview
          groupId={groupId}
          groupNumber={groupNumber}
          periodId={period.id}
          user={user}
        />
      </>
    );
  }

  return (
    <>
      <Typography variant="h4" align="center" gutterBottom marginTop={1}>
        {projectType}
      </Typography>
      <PdfPreviewBox>
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="Previsualización del PDF"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        ) : (
          <Typography>Cargando ...</Typography>
        )}
      </PdfPreviewBox>
      {/* Botón para descargar el PDF */}
      <DownloadButton variant="contained" onClick={downloadFile}>
        Descargar PDF
      </DownloadButton>
    </>
  );
};

export default ProjectPdfComponent;
